// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"56b31daa","239":"eab0352a","455":"3d67e440"}[chunkId] + ".chunk.js";
};